import './home.css'
import Image from 'react-bootstrap/Image'
import heroImage from '../images/heroImage.webp'
import Button from 'react-bootstrap/Button'


function Home(){
    return(
        <div id="hero">
            <title>Home Page - Holistic Green Things</title>
            <meta name ="description" content="Welcome to Holistic Green Things" />
            <img src={heroImage} id="heroImage" alt="Items grown and made in our urban kitchen"/>
            <div id="imageOverlay">
                <p id="imageHeader">
                    Tucson’s Local Source for Fresh Microgreens, Gourmet Mushrooms & Artisan Eats
                </p>
                <p id="imageBody">
                    Shop online for convenient home delivery, pre-order for quick pickup, or visit 
                    us this weekend at the farmers market.
                </p>
                <Button className="home-button" variant="success" size="lg" onClick={() => window.open("https://www.holisticgreenthings.com/Microgreens", "_blank", "noreferrer ,noopener")}>
                    Shop Now
                </Button>
                <Button className="home-button" variant="success" size="lg" onClick={() => window.open("https://www.holisticgreenthings.com/events", "_blank", "noreferrer, noopener")}>
                    Market Schedule
                </Button>
               
            </div>    


        </div>

    )
}

export default Home